/**
 * 标签定义类型定义
 * Tag Definition Types
 */

// ============================================================
// 标签分类类型
// ============================================================

export type TagCategory = 'personality' | 'interest' | 'behavior' | 'achievement' | 'history';

// ============================================================
// 标签分类信息
// ============================================================

export interface TagCategoryInfo {
  code: TagCategory;
  name: string;
  description?: string;
  color?: string;
  count: number;
}

// ============================================================
// 标签定义
// ============================================================

export interface TagDefinition {
  id: number;
  tag_name: string;
  tag_category: TagCategory;
  display_name: string;
  description?: string;
  icon?: string;
  color?: string;
  default_score: number;
  weight: number;
  auto_sources?: Record<string, any>;
  is_active: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

// ============================================================
// 标签选项（用于 Select 组件）
// ============================================================

export interface TagOption {
  value: string;
  label: string;
  color?: string;
}

// ============================================================
// 按分类查询响应
// ============================================================

export interface TagsByCategoryResponse {
  category: TagCategory;
  category_name: string;
  tags: TagOption[];
}

// ============================================================
// 标签列表响应
// ============================================================

export interface TagListResponse {
  total: number;
  page: number;
  page_size: number;
  items: TagDefinition[];
}

// ============================================================
// 请求类型
// ============================================================

export interface TagDefinitionCreate {
  tag_name: string;
  tag_category: TagCategory;
  display_name: string;
  description?: string;
  icon?: string;
  color?: string;
  default_score?: number;
  weight?: number;
  is_active?: boolean;
  sort_order?: number;
  auto_sources?: Record<string, any>;
}

export interface TagDefinitionUpdate {
  display_name?: string;
  description?: string;
  icon?: string;
  color?: string;
  default_score?: number;
  weight?: number;
  auto_sources?: Record<string, any>;
  is_active?: boolean;
  sort_order?: number;
}

// ============================================================
// 查询参数
// ============================================================

export interface TagQueryParams {
  page?: number;
  page_size?: number;
  category?: TagCategory;
  is_active?: boolean;
  search?: string;
}

// ============================================================
// 批量操作
// ============================================================

export interface TagBatchCreateRequest {
  tags: TagDefinitionCreate[];
}

export interface TagBatchCreateResponse {
  created_count: number;
  failed_count: number;
  created_tags: TagDefinition[];
  errors: Array<{
    index: number;
    tag_name: string;
    category: string;
    error: string;
  }>;
}

// ============================================================
// 标签分类配置
// ============================================================

export const TAG_CATEGORIES: Record<TagCategory, { name: string; description: string; color: string }> = {
  personality: { name: '性格标签', description: '描述玩家性格特点的标签', color: '#722ed1' },
  interest: { name: '兴趣标签', description: '描述玩家兴趣爱好的标签', color: '#52c41a' },
  behavior: { name: '行为标签', description: '描述玩家游戏行为的标签', color: '#faad14' },
  achievement: { name: '成就标签', description: '描述玩家成就的标签', color: '#f5222d' },
  history: { name: '历史记录标签', description: '描述玩家历史记录的标签', color: '#1890ff' },
};

// ============================================================
// API 响应包装
// ============================================================

export interface ApiResponse<T = any> {
  code: number;
  message: string;
  data: T;
}
